export enum CanvasDataFormats {
  Png = 'image/png',
  Jpeg = 'image/jpeg',
}

export default class HtmlHelper {
  getCanvasData(canvasElementId: string, fileFormat = CanvasDataFormats.Png): string | null {
    const canvas = document.getElementById(canvasElementId);

    // @ts-ignore
    return canvas?.toDataURL(fileFormat);
  }

  getLinkElementToDownload(data: string, fileName: string): HTMLAnchorElement {
    const link = document.createElement('a');
    link.setAttribute('download', fileName);
    link.setAttribute('href', data);
    return link;
  }

  getLinkElementToDownloadCanvasData(
    fileName: string,
    canvasElementId: string,
    fileFormat = CanvasDataFormats.Png,
  ): HTMLAnchorElement {
    const data = this.getCanvasData(canvasElementId, fileFormat);

    if (!data) {
      throw Error('Canvas element does not exist');
    }

    return this.getLinkElementToDownload(data, fileName);
  }

  isAtWindowBottom(bottomOffset = 200): boolean {
    return (window.innerHeight + window.scrollY) >= document.body.scrollHeight - bottomOffset;
  }

  getFirstElementByClassName(target: Element, className: string): Element | null {
    const elements = target.getElementsByClassName(className);

    return elements.length > 0 ? elements[0] : null;
  }
}
